import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../customButton";
import DEFAULT_ROUTES from "../../constants/routes";
import RouteNotFoundBody from "./RouteNotFoundBody";

const NotFoundContent = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                minHeight: "calc(100vh - 120px)",
            }}
        >
            <RouteNotFoundBody
                variant="shell"
                description="This page doesn't exist in QA Path. Check the URL or return to a known section."
                actions={
                    <ButtonComponent
                        variant="primary"
                        ctaText="Go to Projects"
                        className="bg-blue600 white"
                        onClick={() => navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`)}
                    />
                }
            />
        </Box>
    );
};

export default NotFoundContent;
